var filteredBlogs;
var currentIndex = 0;
var itemsPerLoad = 3;
var articleDataContainer = document.getElementById("article-data-container");
async function getData(currentUrl) {
  let referArray = currentUrl.split("/");
  let taggs;
  let taggsArray;
  if (currentUrl.includes("tagged")) {
    taggs = referArray[6];
  } else {
    taggs = [];
  }
  if (taggs.includes("+")) {
    if (taggs.includes("?")) {
      let withQArray = taggs.split("?");
      taggsArray = withQArray[0].split("+");
    } else {
      taggsArray = taggs.split("+");
    }
  } else {
    if (taggs.includes("?")) {
      let withQArray = taggs.split("?");
      taggsArray = [withQArray[0]];
    } else {
      taggsArray = [taggs];
    }
  }
  const element = document.getElementById('json_pass');
const url = element.textContent;
  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      filteredBlogs = data.blogs.filter((blog) => {
        return taggsArray.every((tag) => blog.tags.includes(tag));
      });
      data = "";

      const itemCount = filteredBlogs.length;
      const fragment = document.createDocumentFragment();

      const span = document.createElement("span");
      span.textContent = "検索結果：" + itemCount + "件";
      span.className = "search-number";
      fragment.appendChild(span);

      document.getElementById("articles-count").appendChild(fragment);
    })
    .catch((error) => {
      console.error("Error:", error);
      observer.disconnect();
      document.getElementById("situation-container").textContent =
        "ただいま混雑中です。時間をおいてから検索してください。";
    });
}

function loadItems() {
  const itemsToLoad = filteredBlogs.slice(
    currentIndex,
    currentIndex + itemsPerLoad
  );
  itemsToLoad.forEach((blog) => {
    const blogElement = document.createElement("div");
    blogElement.classList.add("dtl-items");
    const linkElement = document.createElement("a");
    linkElement.href = "https://trends.codecamp.jp/blogs/media/" + blog.handle;
    linkElement.className = "txts_box";
    const categoryElement = document.createElement("div");
    categoryElement.className = "pfc_cate";
    categoryElement.textContent = "子供向け対象";
    const titleElement = document.createElement("h3");
    titleElement.className = "fcn_title";
    titleElement.textContent = blog.title;
    const infoList = document.createElement("ul");
    infoList.className = "tp_db";
    const addressElement = document.createElement("li");
    addressElement.className = "tp_db1";
    addressElement.textContent = blog.residence;
    const targetElement = document.createElement("li");
    targetElement.className = "tp_db3";
    targetElement.textContent = blog.target;
    const stationElement = document.createElement("li");
    stationElement.className = "tp_db4";
    stationElement.textContent = blog.station;
    infoList.appendChild(addressElement);
    infoList.appendChild(targetElement);
    infoList.appendChild(stationElement);
    linkElement.appendChild(categoryElement);
    linkElement.appendChild(titleElement);
    linkElement.appendChild(infoList);
    blogElement.appendChild(linkElement);
    articleDataContainer.appendChild(blogElement);
  });
  currentIndex += itemsPerLoad;
  if (currentIndex >= filteredBlogs.length) {
    observer.disconnect();
    if (filteredBlogs.length == 0) {
      document.getElementById("situation-container").textContent =
        "検索結果は0件です。";
    } else {
      document.getElementById("situation-container").textContent = "";
    }
  }
}
const option_setting = {
  root: null,
  rootMargin: "0px",
  threshold: 1.0,
};
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      setTimeout(function () {
        loadItems();
      }, 500);
    }
  });
}, option_setting);
document.addEventListener("DOMContentLoaded", () => {
  const currentUrl = window.location.href;
  getData(currentUrl);
  const sentinel = document.getElementById("sentinel");
  observer.observe(sentinel);
});